import MarkdownIt from "markdown-it"
import mk from "@iktakahiro/markdown-it-katex"
import hljs from "highlight.js"
import { getBaseURL } from "@/utils/request"
const baseURL = getBaseURL();
const md = new MarkdownIt({
    html: true,
    linkify: false,
    strict: false,
    maxSize: 20, // 最大字体尺寸
    minSize: 12, // 最小字体尺寸
    highlight: function (str, lang) {
        if (lang && hljs.getLanguage(lang)) {
            try {
                return hljs.highlight(str, { language: lang }).value
            } catch (__) { }
        }
        return (
            '<pre class="hljs"><code>' +
            md.utils.escapeHtml(str) +
            "</code></pre>"
        )
    }

})

// 自定义图片处理器
md.renderer.rules.image = (tokens, idx, options, env, self) => {
    const token = tokens[idx]
    token.attrPush(['class', "click-enlarge"]);
    const srcIndex = token.attrIndex('src')
    if (srcIndex >= 0) {
        // 获取原始src
        let src = token.attrs[srcIndex][1]
        // 修复：同时匹配png、gif base64 和 http外链
        if (src.includes('data:image/png;base64') || src.includes('data:image/gif;base64') || src.includes('http')) {

            const classIndex = token.attrIndex('class');
            const base64Class = 'base64-image'; // 自定义 class 名称

            if (classIndex < 0) {
                // 没有 class 属性时添加
                token.attrPush(['class', base64Class]);
            } else {
                // 已有 class 属性时追加
                const existingClasses = token.attrs[classIndex][1];
                if (!existingClasses.includes(base64Class)) {
                    token.attrs[classIndex][1] = `${existingClasses} ${base64Class}`;
                }
            }

            token.attrPush(['data-image-type', 'base64']);

        } else {
            // 本地相对路径拼接域名
            src = `${baseURL}/${src}`
        }

        // 更新token的src属性
        token.attrs[srcIndex][1] = src
    }

    // 使用默认的渲染器渲染图片
    return self.renderToken(tokens, idx, options)
}

md.use(mk,
    // markdown-it-katex 的配置
    {
        throwOnError: true,
        errorColor: '#cc0000',
        // 定义自定义命令，将 \x 映射为 \cdot
        macros: {
            "\\x": "\\cdot",
            "\\begin{cases}": "\\left\\{\\begin{array}{l}",
            "\\end{cases}": "\\end{array}\\right.",
            "\\gt": ">",      // 添加对 > 的支持
            "\\lt": "<",      // 添加对 < 的支持
            "\\mid": "|"      // 添加对 | 的支持
        },
        globalGroup: true,  // 允许公式中包含文本

        // delimiters: [
        //     { left: "$$", right: "$$", display: true },  // 块级公式
        //     { left: "\\[", right: "\\]", display: true }, // 另一种块级公式
        //     { left: "\\(", right: "\\)", display: false }, // 行内公式
        //     { left: "$", right: "$", display: false },    // 另一种行内公式
        //     { left: "\\begin{equation}", right: "\\end{equation}", display: true },
        //     { left: "\\begin{align}", right: "\\end{align}", display: true },
        //     { left: "\\begin{alignat}", right: "\\end{alignat}", display: true },
        //     { left: "\\begin{gather}", right: "\\end{gather}", display: true },
        //     { left: "\\begin{CD}", right: "\\end{CD}", display: true },
        //     // 注意：\begin 和 \end 语法需要 KaTeX 支持，并且可能需要额外的配置
        //     { left: "\\begin{align*}", right: "\\end{align*}", display: true }, // 带星号版本


        // ],
        onError: (error) => {
            console.error("KaTeX Error:", error);
        }
    })

md.use(customCodeBlock)
// 自定义扩展的代码块渲染方法
function customCodeBlock() {
    // 使用原生的 fence 规则，并覆盖其 render 方法
    const defaultRender = md.renderer.rules.fence
    md.renderer.rules.fence = (tokens, idx, options, env, self) => {
        // 调用原生的渲染方法
        const originalRender = defaultRender
            ? defaultRender(tokens, idx, options, env, self)
            : ""

        const token = tokens[idx]
        let lang = token.info.split(" ")[0]
        const langName = token.info ? `language-${token.info.trim()}` : ""

        // 创建带有复制按钮和语言标识的代码头
        const codeHeader = ` <div class="code-top"   ref="codeTopRef">
                                <span class="language-type">${lang}</span>
                                <span class="copy-btn">复制</span>
                            </div>`
        // 调用默认渲染器
        const defaultHtml = defaultRender(tokens, idx, options, env, self)

        // 将代码头添加到默认HTML中
        const html = `<div class="code-block">${codeHeader}${defaultHtml}</div>`

        return html
    }
};

export default md
